<!--
/**
* @name: List.vue
* @description: 文章管理-添加素材页面
* @author: yangbo@yuouhui1.com
* @create: 2020/08/31 14:06:58
* @update: 2020/08/31 14:06:58
*/
-->
<template>
  <y-view :title="showType == '1' ? '编辑素材' : '新增素材'" :loading="isLoading">
    <y-form titleAlign="right" titleWidth="100px" contentWidth="100%">
      <y-form-item title="素材标题:" required>
        <k-input :class="css.inputW" placeholder="请输入素材标题" maxlength="20" block clearable
          v-model="editPara.title"></k-input>
      </y-form-item>
      <y-form-item title="素材类型:" required>
        <k-select :class="css.inputW" placeholder="请选择素材类型" block clearable v-model="editPara.type">
          <k-option v-for="item in typeList" :key="item.value" :value="item.value" :label="item.name"
            :selected="editPara.type == item.value">{{ item.name }}</k-option>
        </k-select>
      </y-form-item>
      <y-form-item title="台卡类型:" required v-if="editPara.type === 'mt03'">
        <k-select :class="css.inputW" placeholder="请选择台卡类型" block clearable v-model="editPara.subType">
          <k-option v-for="item in tableCardList" :key="item.value" :value="item.value" :label="item.name"
            :selected="editPara.subType == item.value">{{ item.name }}</k-option>
        </k-select>
      </y-form-item>
      <y-form-item title="销售渠道:" required>
        <k-select :class="css.inputW" placeholder="请选择销售渠道" block clearable v-model="editPara.channelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name"
            :selected="editPara.channelCode == item.code">{{ item.name }}</k-option>
        </k-select>
      </y-form-item>
      <y-form-item title="选择品牌:">
        <k-auto-complete ref="brand" :data="brandList" v-model="editPara.goodsBrandCode" key-field="gbcode"
          value-field="gbname" search-field="gbname" layer-width="" placeholder="请选择商品品牌" :class="css.inputW">
        </k-auto-complete>
      </y-form-item>
      <y-form-item title="选择商品:">
        <k-select2 v-model="editPara.goodsCodeSale" :data="goodsList" text-field="goodsCodeOrNameSale"
          key-field="goodsCodeSale" search-field="goodsNameSale" layer-width="auto" layerMinWidthEqual
          placeholder="请选择商品" :class="css.inputW">
        </k-select2>
      </y-form-item>
      <y-form-item title="素材关键词:" required>
        <k-input :class="css.inputW" placeholder="请输入，用“,”隔开" block clearable v-model="editPara.keyWord"></k-input>
      </y-form-item>
      <y-form-item title="素材序列:" required>
        <k-input :class="css.inputW" placeholder="请输入素材序列" block clearable v-model="editPara.sort"></k-input>
      </y-form-item>
      <y-form-item title="状态:" required>
        <div>
          <k-radio v-model="editPara.status" :value="1">启用</k-radio>
          <k-radio v-model="editPara.status" :value="2">停用</k-radio>
        </div>
      </y-form-item>
      <y-form-item title="素材图片:" required align="top">
        <div class="row">
          <y-upload-file v-if="editPara.type === 'mt03' && editPara.imageDTOList.length === 0" fileType="image"
            :uploadUrl="uploadUrl" @uploaded="onUploaded"></y-upload-file>
          <y-upload-file v-if="editPara.type != 'mt03' && editPara.imageDTOList.length < 9" fileType="image"
            :uploadUrl="uploadUrl" @uploaded="onUploaded" multiple></y-upload-file>
          <y-image @delete="onDelete" v-dragging="{ list: editPara.imageDTOList, item: img, group: 'image' }"
            v-for="(img, index) in editPara.imageDTOList" :key="index" :index="index" :src="img.url"></y-image>
        </div>
        <div class="mt-1" v-if="editPara.type === 'mt03' && editPara.subType === 'DESK_CARD_A5'">
          （说明：最多上传1张，图片尺寸为1748*2480）</div>
        <div class="mt-1" v-if="editPara.type === 'mt03' && editPara.subType === 'DESK_CARD_V'">
          （说明：最多上传1张，图片尺寸为1181*827）</div>
        <div class="mt-1" v-if="editPara.type != 'mt03'">（说明：最多上传9张，最少1张，图片尺寸为750*750）</div>
      </y-form-item>

      <y-form-item title="首页是否带二维码:" required>
        <div>
          <k-radio v-model="editPara.hasQrcode" :value="1">是</k-radio>
          <k-radio v-model="editPara.hasQrcode" :value="0">否</k-radio>
        </div>
      </y-form-item>
      <y-form-item title="二维码位置:" required align="top" v-if="editPara.hasQrcode == 1">
        <div class="row">
          二维码右下角距离右边&nbsp;&nbsp;<k-input :class="css.inputQRCode" type="number" placeholder="请输入" clearable
            v-model="QRBottom"></k-input>&nbsp;&nbsp;像素，
          距离底部&nbsp;&nbsp;<k-input :class="css.inputQRCode" type="number" placeholder="请输入" clearable
            v-model="QRRight"></k-input>&nbsp;&nbsp;像素

        </div>
      </y-form-item>
      <y-form-item title="二维码尺寸:" required align="top" v-if="editPara.hasQrcode == 1">
        <k-input :class="css.inputW" placeholder="请输入" type="number" block clearable v-model="QRWidth"></k-input>
        <div style="margin-top: 10px">二维码默认尺寸：469*469，自定义只需要大于等于200</div>
      </y-form-item>



      <y-form-item title="文章内容:" required align="top">
        <div :class="css.ueditorW">
          <ueditor v-model="editPara.content"></ueditor>
        </div>
      </y-form-item>
    </y-form>
    <div slot="bottom">
      <k-button @click="onReset" v-if="showType == 1">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST,
  NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_ADD,
  NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_INFO,
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST,
  NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_UPDATE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  title: "", //素材标题
  type: "", //素材类型编码
  subType: "", //台卡类型编码
  channelCode: "", //销售渠道编码
  goodsCodeSale: "", //商品编码
  goodsBrandCode: "", //品牌编码
  goodsBrandName: "", //品牌名称
  keyWord: "", //素材关键字
  sort: "", //素材序列
  status: "", //素材状态
  imageDTOList: [], //素材图片
  content: "", //素材内容
  hasQrcode: 0,//是否携带二维码
  qrCodeConfigDTO: {
    bottom: 0,
    right: 0,
    qrCodeWidth: 469

  },//二维码配置
});
export default {
  data() {
    return {
      QRBottom: 0,
      QRRight: 0,
      QRWidth: 469,

      typeList: [], //素材类型列表
      channelList: [], //销售渠道列表
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      goodsList: [], //商品列表
      brandList: [], //品牌列表
      isLoading: false,
      editPara: initEditPara(),
      isSaving: false,
      tableCardList: [], //台卡类型列表
      showType: 0,
      originData: {},
    };
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      let title = para.title.toString().replace(/\s*/g, "");
      if (
        title.length < 2 ||
        title.length > 20 ||
        !para.type ||
        (para.type === "mt03" && !para.subType) ||
        !para.channelCode ||
        (para.type == "1" && !para.goodsCodeSale) ||
        !para.keyWord ||
        (!para.sort && para.sort != "0") ||
        !para.status ||
        (para.imageDTOList && para.imageDTOList.length === 0) ||
        !para.content || (para.hasQrcode && (!this.QRBottom || !this.QRRight || !this.QRWidth))
      ) {
        status = true;
      }
      return status;
    },
  },

  watch: {
    "editPara.type": function (val) {
      if (val != "mt03") {
        this.editPara.subType = "";
      }
    },
  },

  methods: {
    /** 素材图片上传回调 */
    onUploaded(data) {
      for (let i = 0; i < data.data.length; i++) {
        this.editPara.imageDTOList.push({ url: data.data[i].url });
      }
    },

    /** 获取素材详情信息 */
    getMaterialDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_INFO,
        para: { materialId: id },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.originData = res.imageVOList;
          this.editPara = { ...this.editPara, ...res };
          this.editPara.imageDTOList = res.imageVOList;
          if (res.hasQrcode) {
            this.QRBottom = res.qrCodeConfigDTO.bottom
            this.QRRight = res.qrCodeConfigDTO.right
            this.QRWidth = res.qrCodeConfigDTO.qrCodeWidth
          }


          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 点击返回素材列表页面 */
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "materialManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },

    /** 重置素材详情信息 */
    onReset() {
      this.$refs.brand.inputText = '';
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },

    /** 保存当前素材信息 */
    onSave() {
      if (this.isSaving) return;
      if (this.editPara.goodsBrandCode) {
        let arrayTemp = this.brandList.filter((c) => c.gbcode == this.editPara.goodsBrandCode);
        this.editPara.goodsBrandName = arrayTemp[0].gbname;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (para.imageVOList && para.imageVOList.length > 0) delete para.imageVOList;

      if (para.hasQrcode == 1) {
        para.qrCodeConfigDTO = {
          bottom: this.QRBottom,
          right: this.QRRight,
          qrCodeWidth: this.QRWidth
        }
      } else {
        para.qrCodeConfigDTO = {}
      }

      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({ api: this.showType == "1" ? NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_UPDATE : NESTLE_ARTICLE_BACK_SERVER_BACK_MATERIAL_ADD, para })
        .then(() => {
          this.isSaving = false;
          this.isLoading = false;
          this.$root.tip("操作成功", "success");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },

    /** 删除当前素材图片信息 */
    onDelete(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.editPara.imageDTOList.splice(obj.index, 1);
        },
      });
    },

    /** 初始化页面下拉选择options数据 */
    initData() {
      // 获取素材类型列表数据
      this.$fetch({ api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE, para: { parentCode: "materialType" } }).then((res) => {
        this.typeList = res || [];
      });
      // 获取台卡类型列表数据
      this.$fetch({ api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE, para: { parentCode: "DESK_CARD_SUB_LIST" } }).then((res) => {
        this.tableCardList = res || [];
      });
      // 获取主数据商品列表数据
      this.$fetch({ api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST, para: {} }).then((res) => {
        let data = res || [];
        data.forEach((item) => {
          item.goodsCodeOrNameSale = `${item.goodsCodeSale} — ${item.goodsNameSale}`;
        });
        this.goodsList = data;
      });
      //  获取销售渠道列表数据
      this.$fetch({ api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST, para: {} }).then((res) => {
        this.channelList = res || [];
      });
      // 获取商品品牌列表数据
      this.$fetch({ api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_BRAND_LIST, para: {} }).then((res) => {
        this.brandList = res || [];
      });
    },
  },
  created() {
    const { id, showType } = this.$route.query;
    this.initData();
    this.showType = showType;
    if (id) this.getMaterialDetail(id);
  },
  beforeRouteUpdate(to, from, next) {
    const { id, showType } = to.query;
    this.editPara = initEditPara();
    this.$refs.brand.inputText = "";
    this.showType = showType;
    if (id) this.getMaterialDetail(id);
    next();
  },
};
</script>

<style lang="postcss" module="css">
.inputW {
  width: 400px !important;
}

.inputQRCode {
  width: 100px !important;
}

.ueditorW {
  width: 800px !important;
}
</style>
